// src/context/AuthContext.js (Public Portal version)
import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import { login as apiLogin, getMe as apiGetMe, register as apiRegister } from '../services/api'; // Assuming register is added to api.js
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem('publicAuthToken')); // Use a different key maybe?
    const [loading, setLoading] = useState(true);

    // Function to fetch user details
     const fetchUser = useCallback(async () => {
         try {
             const response = await apiGetMe();
             setUser(response.data);
         } catch (error) {
             console.error("Failed to fetch user:", error);
             logout(); // Log out if /me fails
         } finally {
             setLoading(false);
         }
     }, []);


    useEffect(() => {
        const currentToken = localStorage.getItem('publicAuthToken');
        if (currentToken) {
            setToken(currentToken);
            fetchUser(); // Fetch user details if token exists
        } else {
            setLoading(false);
        }
    }, [fetchUser]); // Add fetchUser dependency

    const login = async (email, password) => {
        try {
            const response = await apiLogin(email, password);
            const { token: bearerToken, user: loggedInUser } = response.data;
            localStorage.setItem('publicAuthToken', bearerToken);
            setToken(bearerToken);
            setUser(loggedInUser);
            return true;
        } catch (error) {
            console.error("Login failed:", error);
            logout();
            throw error;
        }
    };
    const loginWithToken = (jwtToken, userData, zamPassIdToken) => {
        console.log("AuthContext: Performing loginWithToken...");
            try {
                // 1. Update state
                localStorage.setItem('publicAuthToken', jwtToken)

                if (zamPassIdToken) {
                    localStorage.setItem('zamPassIdToken', zamPassIdToken);
                }
                setToken(jwtToken);
                setUser(userData);
            } catch (error) {
                console.error("Login failed:", error);
                logout(); // Clear any leftover state on failure
                throw error; // Re-throw for the login page to handle
            }
    };

    const register = async (name, email, password) => {
         try {
            // Call the registration API endpoint
            await apiRegister({ name, email, password });
            // Optional: Log the user in automatically after registration
            // await login(email, password);
            return true; // Indicate registration success
         } catch(error) {
             console.error("Registration failed:", error);
             throw error; // Re-throw for the registration page
         }
    };

    const logout = () => {
        localStorage.removeItem('publicAuthToken');
        setUser(null);
        setToken(null);
        localStorage.removeItem('zamPassIdToken');
    };

    const value = { user, token, isAuthenticated: !!token && !!user, loading, login, register, logout, loginWithToken };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined || context === null) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};